import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=3280ee26&lang=pug&"
import script from "./Countdown.vue?vue&type=script&lang=ts&"
export * from "./Countdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports